export default __webpack_public_path__ + "assets/72dbb6d334bd6858acfe09edb2987155.png";